import React, { useCallback } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

type SelectOption = {
  label: string;
  value: string | number;
};

interface InlineSelectCellRendererProps extends Partial<ICellRendererParams> {
  options: SelectOption[];
  isEditable?: boolean;
  onValueChange?: (newValue: string | number | null) => void;
}

const InlineSelectCellRenderer = ({
  value,
  options,
  isEditable,
  onValueChange,
}: InlineSelectCellRendererProps) => {
  const label = options.find(option => String(option.value) === String(value))?.label ?? '';

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const match = options.find(option => String(option.value) === event.target.value);
      onValueChange?.(match ? match.value : null);
    },
    [onValueChange, options],
  );

  if (!isEditable) {
    return <span>{label}</span>;
  }

  const selectedValue = options.some(option => String(option.value) === String(value))
    ? String(value)
    : '';

  return (
    <span className="slt-inline-select-cell-wrapper" onClick={event => event.stopPropagation()}>
      <select
        className="slt-inline-select-cell"
        value={selectedValue}
        onMouseDown={event => event.stopPropagation()}
        onClick={event => event.stopPropagation()}
        onChange={handleChange}
      >
        <option value="" disabled>
          Select option
        </option>
        {options.map(option => (
          <option key={String(option.value)} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
    </span>
  );
};

export default InlineSelectCellRenderer;
